import { Button, CircularProgress } from "@mui/material";

/**
 * A button component that displays a loading state, while keeping the children visible.
 *
 * @param {boolean} loading - Whether the button is in a loading state.
 * @param {React.ReactNode} children - The button's content (text or elements).
 * @param {Object} progressProps - Props to customize the CircularProgress.
 * @param {Object} buttonProps - Any other props to pass to the button.
 */
export function LoadingButton({
  loading,
  children,
  progressProps,
  ...buttonProps
}) {
  return (
    <Button {...buttonProps} disabled={loading || buttonProps.disabled}>
      {children}
      {loading && (
        <CircularProgress
          size={24}
          sx={{ marginLeft: 1, zIndex: 1 }}
          {...progressProps}
        />
      )}
    </Button>
  );
}
